(function () {
    'use strict';
    app.service('DataManagementService', ['$http', '$q', '$rootScope',
    function ($http, $q, $rootScope) {

        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
        var deviceInfo = [];
        var deferred;

        this.getFiles = function (userName) {

            deferred = $q.defer();
            $http.get(serviceBase + "api/datamanagement/data").then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });
            return deferred.promise;
        }

        this.uploadFile = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/datamanagement/upload", data, {
                headers: { 'Content-Type': undefined }
            }).then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.updateDatamanagement = function (data) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/datamanagement/updateDatamanagement", data)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.deleteFile = function (ids, files) {
            deferred = $q.defer();

            $http.post(serviceBase + "api/datamanagement/delete?ids=" + ids + "&files=" + files)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.getObjectByObjectID = function (objectId) {
            deferred = $q.defer();

            $http.get(serviceBase + "api/datamanagement/getObjectByObjectID?objectId=" + objectId)
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.getUserStorageCapacityByID = function () {
            deferred = $q.defer();

            $http.get(serviceBase + "api/datamanagement/getUserStorageCapacity")
            .then(function (response) {
                deferred.resolve(response);
            })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }
    }
    ]);
})();